import { environment } from './environment';
import {
	AotCategoryType,
	aotConstants,
	logConstants,
	TraceKind,
} from '../utils/Constants';
import { config } from './AuthConfig';

export class Logger {
	private static instance: Logger;
	static getInstance(): Logger {
		if (!Logger.instance) {
			Logger.instance = new Logger();
		}
		return Logger.instance;
	}

	/// <summary>
	/// writes a trace message to native file
	/// </summary>
	/// <param name="level">log level (Message/Error/Debug)</param>
	/// <param name="message">log message string</param>
	/// <param name="aotCategory">AOT category (Error/Info/Warning/Failure)</param>
	/// <param name="aoTrace">AOT trace string. If undefined, "message" parameter is logged</param>
	write(
		level: string,
		message: string,
		aotCategory?: AotCategoryType,
		aoTrace?: string
	): void {
		switch (level) {
			case logConstants.INFO:
				console.info(message);
				if (config.nativeLoggingEnabled == true) {
					environment.writeAmlTrace(message, TraceKind.Message);
				}
				break;
			case logConstants.ERROR:
				console.error(message);
				if (config.nativeLoggingEnabled == true) {
					environment.writeAmlTrace(message, TraceKind.Error);
				}
				break;
			case logConstants.DEBUG:
				console.debug(message);
				if (config.nativeLoggingEnabled == true) {
					environment.writeAmlTrace(message, TraceKind.Debug);
				}
				break;
			default:
				console.log(message);
				if (config.nativeLoggingEnabled == true) {
					environment.writeAmlTrace(message, TraceKind.Message);
				}
				break;
		}

		if (aotCategory) {
			this.writeAot(aotCategory, aoTrace ?? message);
		}
	}

	/// <summary>
	/// writes an always-on trace message to native file
	/// </summary>
	/// <param name="category">log category (Error/Info/Fatal/Warning)</param>
	/// <param name="trace">log string</param>
	writeAot(category: AotCategoryType, trace: string): void {
		if (config.nativeLoggingEnabled == true) {
			environment.writeAmlTrace(
				`${aotConstants.Authentication} ${trace}`,
				null,
				category
			);
		}
	}
}
